
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a3b8f536&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ButtonCollection.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ButtonCollection.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-a3b8f536!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ButtonCollection.vue"),
  /* scopeId */
  "data-v-a3b8f536",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonCollection.vue
// module id = 365
// module chunks = 0